import { useEffect } from "react";
import { setDocumentTitle } from "@/lib/documentTitle";
import { K1DashboardProvider } from "@/features/K1Dashboard/context/K1DashboardProvider";
import EmailLogsView from "@/features/K1Dashboard/views/EmailLogsView";

export default function K1EmailLogs() {
  useEffect(() => {
    setDocumentTitle("Quantilia | Emails");
  }, []);

  return (
    <K1DashboardProvider>
      <main className="min-h-0 flex flex-1 flex-col overflow-auto bg-white p-5">
        <EmailLogsView />
      </main>
    </K1DashboardProvider>
  );
}
